module.exports = __webpack_public_path__ + "static/media/photo-dump-team.e284d479.webp";